﻿import { epic$, store } from '@redux/store';
import uiStateSlice from 'layout/redux/uiStateSlice';
import { getBuildeablePlanEpic, getCommunityEpic, getPlanEpic, getSpecEpic } from './redux/epics';

epic$.next(getBuildeablePlanEpic);
epic$.next(getCommunityEpic);
epic$.next(getPlanEpic);
epic$.next(getSpecEpic);

export default (id, type) => {
  store.dispatch(uiStateSlice.actions.modalInformation({ id, type, name: 'leadModal' }));
};

require('./components/extendedCard');
